import { Toolbar } from './Toolbar';

export default Toolbar;
export type { ToolbarProps } from './types';
